<div class="modal fade cierre-nomina-modal" [id]="modalId" tabindex="-1" aria-hidden="true"
    data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered cierre-nomina-modal-dialog">
        <div class="modal-content cierre-nomina-modal-content">
            <button type="button" class="cierre-nomina-close-btn" (click)="cancel()" aria-label="Cerrar">
                <i class="ti ti-x"></i>
            </button>

            <div class="cierre-nomina-icon-wrap">
                <img src="assets/img/icons/imss-lock.svg" alt="">
            </div>

            <h4 class="cierre-nomina-title">Cierre total de nómina</h4>

            <ng-container *ngIf="step === 1">
                <p class="cierre-nomina-text">
                    Estás a punto de cerrar la nómina <strong>{{periodLabel}}</strong>
                </p>
                <p class="cierre-nomina-text">
                    El cierre de nómina se debe realizar cuando se ha finalizado el registro de todas las
                    incidencias y movimientos de los trabajadores y solo falte timbrar los recibos electrónicos.
                </p>
                <p class="cierre-nomina-text">
                    En caso de finiquito se puede cerrar la nómina para timbrar los recibos y abrirla nuevamente
                    para finalizar la preparación de la nómina de los trabajadores activos.
                </p>
                <p class="cierre-nomina-text"><strong>¿Deseas continuar?</strong></p>

                <div class="cierre-nomina-actions">
                    <button type="button" class="cierre-nomina-btn cierre-nomina-btn-secondary" (click)="cancel()">Cancelar</button>
                    <button type="button" class="cierre-nomina-btn cierre-nomina-btn-primary" (click)="step = 2">Aceptar</button>
                </div>
            </ng-container>

            <ng-container *ngIf="step === 2">
                <p class="cierre-nomina-text">
                    Al ejecutar el cierre de nómina no podrás realizar cambios en los parámetros del sistema ni de
                    la nómina y solo se podrán aplicar movimientos y cambios individuales a trabajadores que no
                    tengan recibos timbrados.
                </p>
                <p class="cierre-nomina-text">
                    No continúes con este proceso si te encuentras todavía en la preparación de la nómina.
                </p>

                <div class="cierre-nomina-field">
                    <label class="cierre-nomina-label">Clave de usuario</label>
                    <input type="password" class="cierre-nomina-input" [class.is-invalid]="passwordError"
                        [(ngModel)]="password" (ngModelChange)="passwordError = ''"
                        placeholder="Ingresa tu clave de usuario" (keyup.enter)="verifyAndClose()">
                    <div class="cierre-nomina-error" *ngIf="passwordError">{{passwordError}}</div>
                </div>

                <div class="cierre-nomina-actions">
                    <button type="button" class="cierre-nomina-btn cierre-nomina-btn-secondary" (click)="cancel()">Cancelar</button>
                    <button type="button" class="cierre-nomina-btn cierre-nomina-btn-primary" *ngIf="canDo('Cerrar nómina')" [disabled]="submitting"
                        (click)="verifyAndClose()">Realizar cierre total</button>
                </div>
            </ng-container>
        </div>
    </div>
</div>
